<template>
    <div>
        <div class="nav_top">
            <div class="nav_top_m row">
                <div class="nav_top_m_l row">
                    <div @click="tiaozhuan('/')">
                        <img src="@/assets/images/logo.png" style="height: 20px; cursor: pointer;">
                    </div>
                    <div>
                        <a href="/">首页</a>
                    </div>
                    <div>
                        <a @click="tiaozhuan('/search')">搜索</a>
                    </div>
                    <!-- <div>
                        <a href="/gongsi">公司</a>
                    </div> -->
                </div>
                <div class="nav_top_m_r row" v-if="dengluzhuangtai == 0">
                    <div>
                        <a href="https://hr.zhiyuansupin.com/#/login">我要招聘</a>
                    </div>
                    <div>
                        <a href="https://www.zhiyuansupin.com/#/login">我要找工作</a>
                    </div>
                    <div class="nav_top_m_r_dlzc">
                        <a class="nav_top_m_r_denglu" @click="denglu()">登录/注册</a>
                    </div>
                </div>
                <div class="nav_top_m_r row" v-if="dengluzhuangtai == 1">
                    <div>
                        <a @click="tiaozhuan('/chat')" style="position: relative;">消息
                            <span class="xiaoxinum" style="display: inline-block;" v-if="chatUnreadCnt">
                                {{ chatUnreadCnt }}
                            </span>
                        </a>
                    </div>
                    <div>
                        <a @click="tiaozhuan('/resume')">简历</a>
                    </div>
                    <div class="nav_top_m_r_yonghuming">
                        <a class="nav_top_m_r_yonghuming_m row" @click="tiaozhuan('/personal')">
                            <span>{{ nickName }}</span>
                            <img v-if="!imgurl" src="@/assets/images/resumeheader.jpg" class="nav_top_m_r_yonghuming_img">
                            <img v-if="imgurl" :src="imgurl" class="nav_top_m_r_yonghuming_img">
                        </a>
                        <div class="nav_top_m_r_yonghuming_mainlist">
                            <div class="nav_top_m_r_yonghuming_list column">
                                <a class="nav_top_m_r_yonghuming_list_m" @click="tiaozhuan('/personal')">个人中心</a>
                                <a class="nav_top_m_r_yonghuming_list_m" @click="tiaozhuan('/account')">账号与安全中心</a>
                                <!-- <a class="nav_top_m_r_yonghuming_list_m" @click="tiaozhuan('/privacyset')">隐私保护</a> -->
                                <a class="nav_top_m_r_yonghuming_list_m" @click="tiaozhuan('/chat')">消息中心</a>
                                <a class="nav_top_m_r_yonghuming_list_m" @click="tuichudenglu">退出登录</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="width: 100%; height: 50px; "></div>
    </div>
</template>

<script>
export default {
    name: 'LaNavTop',
    components: {},
    data() {
        return {
            dengluzhuangtai: 1,
            nickName: '',
            imgurl: '',
            chatUnreadCnt: 0,
        }
    },
    mounted() {

    },
    activated() {
        if (localStorage.getItem('Authorization')) {
            console.log('localStorage.getItem-->', localStorage.getItem('Authorization'));
            // 获取用户信息
            this.getUserInfo();
        } else {
            this.dengluzhuangtai = 0;
            this.nickName = '';
        }
    },
    methods: {
        childNavtop() {
            this.getChatUnreadCnt();
        },
        login() {
            this.$router.push('/login');
        },
        // 获取用户信息
        async getUserInfo() {
            try {
                let res = await this.$API.getUserInfoApi();
                console.log('获取用户信息-->', res);
                if (res.code == 0) {
                    localStorage.setItem('info', JSON.stringify(res.data));
                    this.dengluzhuangtai = 1;
                    this.nickName = res.data.nickName;
                    this.imgurl = res.data.avatarUrl;
                    this.getChatUnreadCnt();
                } else {
                    this.dengluzhuangtai = 0;
                    this.nickName = '';
                    this.imgurl = '';
                    localStorage.removeItem('Authorization');
                    localStorage.removeItem('info');
                    this.$router.push('/');
                }
            } catch (error) {
                this.dengluzhuangtai = 0;
                this.nickName = '';
                this.imgurl = '';
                localStorage.removeItem('Authorization');
                localStorage.removeItem('info');
            }
        },
        // 退出登录
        async tuichudenglu() {
            let res = await this.$API.postAccountLogoutApi();
            console.log('退出登录-->', res);
            if (res.code == 0) {
                localStorage.removeItem('Authorization');
                localStorage.removeItem('info');
                this.$message.success('安全退出！');
                window.location.reload();
            }
        },
        // 获取未读消息数量
        async getChatUnreadCnt() {
            let res = await this.$API.getChatUnreadCntApi();
            console.log('获取未读消息数量-->', res);
            if (res.code == 0) {
                this.chatUnreadCnt = res.data;
            }
        },
        denglu() {
            this.$router.push('/login');
        },
        tiaozhuan(val) {
            this.$router.push(val);
        },
    }

}
</script>

<style scoped>
.nav_top {
    width: 100%;
    height: auto;
    background: #202329;
    box-shadow: 0 1px 8px rgba(0, 0, 0, .06);
    position: fixed;
    z-index: 1005;
}

.nav_top_m {
    width: 1200px;
    height: 50px;
    margin: auto;
    justify-content: space-between;
    color: #fff;
}

.nav_top_m_l {
    align-items: center;
}

.nav_top_m_l>div {
    margin-right: 20px;
}

.nav_top_m_r {
    align-items: center;
}

.nav_top_m_r>div {
    margin-left: 25px;
}

.nav_top_m_r_denglu {
    text-align: center;
    height: 26px;
    line-height: 26px;
    padding: 3px 11px;
    border: 1px solid #00b277;
    border-radius: 8px;
}

.nav_top_m_r_denglu:hover {
    background: rgba(0, 190, 189, .2);
}

.nav_top_m_r_yonghuming {
    position: relative;
    padding: 5px;
    border-radius: 5px;
    transition: all .2s linear;
}

.nav_top_m_r_yonghuming_m {
    display: inline-flex;
    cursor: pointer;
    align-items: center;
}

.nav_top_m_r_yonghuming_m:hover {
    color: #fff;
}

.nav_top_m_r_yonghuming_img {
    width: 28px;
    height: 28px;
    margin-left: 5px;
    border-radius: 50%;
}

.nav_top_m_r_yonghuming:hover {
    background: hsla(0, 0%, 100%, .2);
}

.nav_top_m_r_yonghuming:hover .nav_top_m_r_yonghuming_mainlist {
    display: block;
}

.nav_top_m_r_yonghuming_mainlist {
    display: none;
    position: absolute;
    top: 30px;
    right: 0;
}

.nav_top_m_r_yonghuming_list {
    width: 150px;
    height: auto;
    overflow: hidden;
    margin-top: 20px;
    background: #fff;
    border-radius: 5px;
    padding: 10px;
    box-shadow: 0 4px 16px 0 hsla(0, 0%, 60%, .2);
}

.nav_top_m_r_yonghuming_list_m {
    display: block;
    width: 110px;
    padding: 12px 20px;
    line-height: 20px;
    color: #222;
    font-size: 14px;
}

.nav_top_m_r_yonghuming_list_m:hover {
    color: #00b277;
    background: #f8f8f8;
    font-weight: 500;
}

.xiaoxinum {
    /* display: none; */
    display: inline-block;
    position: absolute;
    top: -10px;
    left: 30px;
    padding: 0 4px;
    line-height: 15px;
    color: #fff;
    font-size: 12px;
    height: 16px;
    background: #fe574a;
    border-radius: 9px 9px 9px 0;
    z-index: 1;
}
</style>
